import CollectionSplashHero from './CollectionSplashHero';
export * from './CollectionSplashHero';

export default CollectionSplashHero;
